// removed by extract-text-webpack-plugin
module.exports = {"modal-background":"_1ri1e8MERjX9hEdEtcqo9H","modalBackground":"_1ri1e8MERjX9hEdEtcqo9H","open":"_3pebt9disT-6AAZILk3itL","modal":"_2EH6yYdIqG0YY9Skyipd2q","header":"_1KqirDPknQ8ckQH08JRWG_","title":"y-tOBx-1tKZ0rUPXubxim","footer":"TcQ_0G4P4P8JOR882PBbG"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Modal/styles.scss
// module id = 626
// module chunks = 11